// extracted by mini-css-extract-plugin
module.exports = {"ErrorMessage":"index-module--ErrorMessage--1-82m","ErrorIcon":"index-module--ErrorIcon--2LnaW","WarningMessage":"index-module--WarningMessage--wfNDY"};